import {NgModule} from '@angular/core';
import {TileContainerComponent} from './tile-container.component';


@NgModule({
  declarations: [TileContainerComponent],
  imports: [],
  exports: [TileContainerComponent]
})
export class TileContainerModule {
}
